var ConsumerRichCardEvents;

(function (ConsumerRichCardEvents) {
  ConsumerRichCardEvents["OPEN_REFERRAL_MODAL"] = "OPEN_REFERRAL_MODAL";
  ConsumerRichCardEvents["OPEN_EXPERT_RATING_MODAL"] = "OPEN_EXPERT_RATING_MODAL";
  ConsumerRichCardEvents["PATH_CREATE_FROM_CATEGORY_WITH_EXPERT"] = "PATH_CREATE_FROM_CATEGORY_WITH_EXPERT";
  ConsumerRichCardEvents["VIEW_PRODUCT_CURATION"] = "VIEW_PRODUCT_CURATION";
  ConsumerRichCardEvents["VIEW_EXPERIENCE_CURATION"] = "VIEW_EXPERIENCE_CURATION";
  ConsumerRichCardEvents["VIEW_EXPERIENCE_ORDER"] = "VIEW_EXPERIENCE_ORDER";
  ConsumerRichCardEvents["VIEW_ORDER"] = "VIEW_ORDER";
  ConsumerRichCardEvents["VIEW_ORDER_CHECKOUT"] = "VIEW_ORDER_CHECKOUT";
  ConsumerRichCardEvents["GIFT_CARD_ORDER"] = "GIFT_CARD_ORDER";
  ConsumerRichCardEvents["VIEW_EXPERT_PROFILE"] = "VIEW_EXPERT_PROFILE";
  ConsumerRichCardEvents["VIEW_ORDER_SUPPORT"] = "VIEW_ORDER_SUPPORT";
  ConsumerRichCardEvents["VIEW_ACCOUNT_PAGE"] = "VIEW_ACCOUNT_PAGE";
  ConsumerRichCardEvents["VIEW_SELLABLE_SEARCH_PAGE"] = "VIEW_SELLABLE_SEARCH_PAGE";
})(ConsumerRichCardEvents || (ConsumerRichCardEvents = {}));

export { ConsumerRichCardEvents };
//# sourceMappingURL=index.js.map
